import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import NewslettersPageForm from '../../../../components/newsletters/newsletters_page_form_with_state';
import nlData from './newsletters_page_data';

let scriptjs = false;
class NewsletterPage extends Component {
  componentDidMount() {
    // eslint-disable-next-line global-require
    scriptjs = require('scriptjs');
    scriptjs('https://www.google.com/recaptcha/api.js');
  }

  render() {
    if (this.props.staticPage.error) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.staticPage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { config } = this.props;
    const newslettersConfig = get(config, 'newsletters');
    const listsDictionary = get(newslettersConfig, 'listsById');
    const allIds = get(newslettersConfig, 'allIds');

    return (
      <section className="container">
        <NewslettersPageForm
          config={config}
          newsletterIds={allIds}
          listsDictionary={listsDictionary}
          sections={nlData}
          hed="Never miss a story."
          dek="Get the latest stories and updates sent your inbox."
        />
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    staticPage: state.staticPage || {},
    config: state.config
  };
}

NewsletterPage.propTypes = {
  config: PropTypes.shape({
    newsletters: PropTypes.shape({}).isRequired
  }).isRequired,
  staticPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired
};

export default connect(mapStateToProps)(NewsletterPage);



// WEBPACK FOOTER //
// ./src/views/containers/pages/newsletters/newsletters_page/newsletters_page.js